import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconDirectory = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
    <path
      d="M11 4H16.5C18.9853 4 21 6.01472 21 8.5M12.1027 5.24371L11.3973 4.25629C10.8342 3.4679 9.925 3 8.95615 3H7C4.23858 3 2 5.23858 2 8V16C2 18.7614 4.23858 21 7 21H17C19.7614 21 22 18.7614 22 16V11.5C22 8.73858 19.7614 6.5 17 6.5H14.5439C13.575 6.5 12.6658 6.0321 12.1027 5.24371Z"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
    />
    <path
      d="M12 16.5H18"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)
